(function() {
  'use strict';

  const config = window.campaignConfig || {
    landingPages: '',
    cookieDuration: '7',
    targetProducts: []
  };

  const STORAGE_KEY = 'campaign_subscription_autoselect';

  function setCampaignActive(days) {
    const durationDays = parseInt(days, 10) || 0;
    
    if (durationDays === 0) {
      try {
        sessionStorage.setItem(STORAGE_KEY, 'true');
      } catch (e) {}
    } else {
      try {
        const now = new Date();
        const item = {
          value: 'true',
          expiry: now.getTime() + (durationDays * 24 * 60 * 60 * 1000)
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(item));
      } catch (e) {}
    }
  }

  function getCampaignActive() {
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
        return true;
      }
    } catch (e) {}

    try {
      const itemStr = localStorage.getItem(STORAGE_KEY);
      if (itemStr) {
        const item = JSON.parse(itemStr);
        const now = new Date();
        if (now.getTime() < item.expiry) {
          return true;
        }
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {}

    return false;
  }

  function extractNormalizedPath(input) {
    if (!input) return '';
    let val = input.trim();
    
    if (val.indexOf('//') > -1) {
      try {
        const urlObj = new URL(val);
        val = urlObj.pathname;
      } catch (e) {
        const parts = val.split('//')[1].split('/');
        parts.shift();
        val = '/' + parts.join('/');
      }
    } else if (val.indexOf('.') > -1 && val.indexOf('/') > -1 && val.indexOf('.') < val.indexOf('/')) {
      val = val.substring(val.indexOf('/'));
    }

    if (!val.startsWith('/')) {
      val = '/' + val;
    }
    
    return val.replace(/\/+$/, '').toLowerCase();
  }

  function checkCampaignLanding() {
    if (!config.landingPages) return;

    const configuredPages = config.landingPages
      .split(/[\n,]/)
      .map(p => extractNormalizedPath(p))
      .filter(p => p.length > 0);

    const currentPath = extractNormalizedPath(window.location.pathname);

    const isMatch = configuredPages.some(pagePath => currentPath === pagePath);

    let isReferrerMatch = false;
    if (document.referrer) {
      try {
        const referrerUrl = new URL(document.referrer);
        if (referrerUrl.origin === window.location.origin) {
          const referrerPath = extractNormalizedPath(referrerUrl.pathname);
          isReferrerMatch = configuredPages.some(pagePath => referrerPath === pagePath);
        }
      } catch (e) {}
    }

    if (isMatch || isReferrerMatch) {
      setCampaignActive(config.cookieDuration);
    }
  }

  let selectionAttempted = false;

  function tryAutoSelectSubscription() {
    if (selectionAttempted) return true;

    let selected = false;

    const subCard = document.querySelector('.kaching-bundles__subscriptions__card');
    if (subCard) {
      const kachingSubBar = subCard.closest('.kaching-bundles__bar[aria-checked="false"]');
      if (kachingSubBar) {
        kachingSubBar.click();
        kachingSubBar.setAttribute('aria-checked', 'true');
        kachingSubBar.dispatchEvent(new Event('change', { bubbles: true }));
        selected = true;
      } else {
        const activeSubBar = subCard.closest('.kaching-bundles__bar[aria-checked="true"]');
        if (activeSubBar) {
          selected = true;
        }
      }
    }

    if (!selected) {
      const sellingPlanSelects = document.querySelectorAll('select[name="selling_plan"]');
      sellingPlanSelects.forEach(select => {
        const subOption = Array.from(select.options).find(opt => opt.value !== '');
        if (subOption && select.value !== subOption.value) {
          select.value = subOption.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          selected = true;
        }
      });

      const sellingPlanRadios = document.querySelectorAll('input[type="radio"][name="selling_plan"]');
      sellingPlanRadios.forEach(radio => {
        if (radio.value !== '' && !radio.checked) {
          radio.checked = true;
          radio.click();
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          selected = true;
        }
      });
    }

    if (selected) {
      selectionAttempted = true;
      document.dispatchEvent(new CustomEvent('campaign:subscription:autoselected'));
      setTimeout(function() {
        document.dispatchEvent(new CustomEvent('kaching:subscription:changed'));
        document.dispatchEvent(new CustomEvent('kaching:selling_plan:changed'));
      }, 100);
    }

    return selected;
  }

  // --- Run Logic ---
  function init() {
    checkCampaignLanding();

    const isProductPage = window.location.pathname.includes('/products/') || document.querySelector('product-info') || document.querySelector('form[action*="/cart/add"]');
    const isCampaignActive = getCampaignActive();

    if (isProductPage && isCampaignActive) {
      if (config.targetProducts && config.targetProducts.length > 0) {
        const currentHandle = config.currentProductHandle || extractNormalizedPath(window.location.pathname).replace('/products/', '');
        if (!config.targetProducts.includes(currentHandle)) {
          return;
        }
      }

      if (tryAutoSelectSubscription()) return;

      let pollCount = 0;
      const maxPoll = 50;
      const interval = setInterval(function() {
        pollCount++;
        const done = tryAutoSelectSubscription();
        if (done || pollCount >= maxPoll) {
          clearInterval(interval);
        }
      }, 150);

      const target = document.querySelector('product-info') || document.querySelector('form[action*="/cart/add"]') || document.body;
      if (target) {
        const observer = new MutationObserver(function() {
          if (tryAutoSelectSubscription()) {
            observer.disconnect();
          }
        });
        observer.observe(target, { childList: true, subtree: true });
        setTimeout(() => observer.disconnect(), 10000);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
